<template>
    <v-flex md12 v-if="!loadingCaseForms">
      <v-flex md2 d-inline-flex>
        I,
      </v-flex>
      <v-flex md5 d-inline-flex>
        <v-text-field
          class="required"
          label="Name"
          v-model="localClientFormData.name"
          :rules="nameRules"
        ></v-text-field>
      </v-flex>
      <v-flex md5 xs12 d-inline-flex>
        <v-text-field
          class="required"
          label="NRIC/FIN Number"
          v-model="localClientFormData.nric_fin_number"
          :rules="nricFinNumberRules"
        ></v-text-field>
      </v-flex>
      <v-flex d-inline-flex>
        have acknowledged receipt of and accepted the above mentioned Service Agreement that outlines the terms and
        conditions of the services provided, and hereby authorise “Direct Funeral Services Pte Ltd” to bill myself based
        on the above information provided.
      </v-flex>
      <v-spacer></v-spacer>

      <v-flex xs12>
        <v-text-field
          class="required"
          label="Contact Number"
          v-model="localClientFormData.contact_number"
          :rules="contactNumberRules"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          class="required"
          label="Email"
          v-model="localClientFormData.email"
          :rules="emailRules"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>

        <v-select
          class="required"
          label="Relationship with deceased"
          v-model="localClientFormData.relationship_with_deceased"
          :rules="relationshipWithDeceasedRules"
          :items="[
            'Husband',
            'Wife',
            'Son',
            'Daughter',
            'Son in law',
            'Daughter in law',
            'Brother',
            'Sister',
            'Brother in law',
            'Sister in law',
            'Uncle',
            'Auntie',
            'Nephew',
            'Niece',
            'Cousin',
            'Friend',
            'Social worker',
            'Others'
          ]"></v-select>
      </v-flex>
    </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        formData: 'getOnBoardClientFormAnswers',
        editable: 'isOnBoardClientFormAnswersEditable',
        loadingCaseForms: 'getLoadingFormsStatus'
      })
    },
    data () {
      return {
        localClientFormData: [],
        nameRules: [
          v => !!v || 'Required'
        ],
        nricFinNumberRules: [
          v => !!v || 'Required'
        ],
        contactNumberRules: [
          v => !!v || 'Required'
        ],
        emailRules: [
          v => /.+@.+/.test(v) || 'Required email'
        ],
        relationshipWithDeceasedRules: [
          v => !!v || 'Required'
        ],
        valid: false
      }
    },
    props: {
      clientName: String
    },
    watch: {
      valid (status) {
        this.$store.commit('updateClientOnBoardForm', this.localClientFormData)
        this.$emit('valid:changed', status)
      },
      localClientFormData: {
        handler (newObject) {
          this.$emit('clientdata:input', newObject)
        },
        deep: true
      },
      clientName (name) {
        this.localClientFormData.name = name
      },
      formData () {
        this.caseSelected = this.caseid
        this.localClientFormData = this.formData.client_form_data
      }
    },
    created () {
      this.localClientFormData = this.formData.client_form_data
    }
  }
</script>



// WEBPACK FOOTER //
// DfsServiceAgreementClientData.vue?5afda1d4